module.exports = __webpack_public_path__ + "assets/img/Pioneer_Chokron_cover.f0966b7c-ps.jpg";